import forOwn from 'lodash/forOwn'
import isNil from 'lodash/isNil'
import reduce from 'lodash/reduce'
import React, { createContext, useReducer } from 'react'

import { SESSIONS } from '@src/config/constants'
import getSessionStorage from '@src/utils/getSessionStorage'

export type Props = {
  children: React.ReactNode
  showConfirmedSession: boolean
}

export type FilterValueType = string | boolean
export type FilterMapType = Map<string, FilterValueType>
interface FilterReducerAction {
  type: string
  key?: string
  value?: FilterValueType
}
export type SelectedFiltersContextType = {
  filters: FilterMapType
  dispatch?: React.Dispatch<FilterReducerAction>
}

const initialState: SelectedFiltersContextType = {
  filters: new Map(),
}
const SelectedFiltersContext = createContext<SelectedFiltersContextType>(initialState)

export const FILTERS_ACTIONS = {
  SET: `set`,
  DELETE: `delete`,
  DELETE_ALL: `delete_all`,
}

// Reducer to be used:
const filtersReducer: React.Reducer<FilterMapType, FilterReducerAction> = (state, action) => {
  // Create immutable state:
  const m = new Map(state)
  switch (action.type) {
    case FILTERS_ACTIONS.SET:
      if (action.key && action.value) {
        m.set(action.key, action.value)
      }
      break

    case FILTERS_ACTIONS.DELETE:
      if (action.key) {
        m.delete(action.key)
      }
      break
    case FILTERS_ACTIONS.DELETE_ALL:
      m.clear()
      break

    default:
      throw new Error(`No reducer default allowed. (SelectedFiltersContextProvider)`)
  }
  const storage = getSessionStorage()

  // const filters = Object.fromEntries(m.entries()) /// NEED A POLYFILL. Code below:
  const keys: string[] = Array.from(m.keys())
  const filters = {}
  reduce(
    keys,
    (carry, key) => {
      carry[key] = m.get(key)
      return carry
    },
    filters
  )

  if (!isNil(storage)) {
    storage.set(SESSIONS.CATALOG_FILTERS_KEY, filters)
  }
  return m
}

function SelectedFiltersContextProvider({ children, showConfirmedSession }: Props) {
  const storage = getSessionStorage()
  const savedState = !isNil(storage) ? storage.get(SESSIONS.CATALOG_FILTERS_KEY) : null
  const initialFilters = []
  if (savedState) {
    forOwn(savedState, (value: string, key: string) => {
      // @ts-expect-error - TODO: fix this
      initialFilters.push([key, value])
    })
  }

  if (showConfirmedSession) {
    // @ts-expect-error - TODO: fix this
    initialFilters.push([`SessionsConfirmed`, true])
  }

  const [filters, dispatch]: [FilterMapType, React.Dispatch<FilterReducerAction>] = useReducer(
    filtersReducer,
    new Map(initialFilters)
  )
  const value = { filters, dispatch }

  return <SelectedFiltersContext.Provider value={value}>{children}</SelectedFiltersContext.Provider>
}

export { SelectedFiltersContext, SelectedFiltersContextProvider }
